// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__r8kPG","label":"Category_label__3t7y6","content":"Category_content__1JzGa","header":"Category_header__2CGm1","location":"Category_location__3WTRs"};